module.exports = __webpack_public_path__ + "static/media/Brachydios.fcd0ee53.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Brachydios.png
// module id = 101
// module chunks = 0